import { render, staticRenderFns } from "./blob_content_viewer.vue?vue&type=template&id=5065d50a&scoped=true&vue3"
import script from "./blob_content_viewer.vue?vue&type=script&lang=js&vue3"
export * from "./blob_content_viewer.vue?vue&type=script&lang=js&vue3"
import style0 from "./blob_content_viewer.vue?vue&type=style&index=0&id=5065d50a&prod&scoped=true&lang=css&vue3"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5065d50a",
  null
  
)

export default component.exports